import Rails from "@rails/ujs";
import { General } from './general'
import jQuery from "jquery";

const CartsShowView = {

  init: function() {
    CartsShowView.validation();
    CartsShowView.cartsItemChange();
  },
  validation: function() {
    $(document).ready(function(){
      $(".edit_cart").validate();
      let form = $(".edit_cart")
      // link to next step is not available until form is valid
      $('#to-checkout').on('click', function() {
        if (form.valid()==false) {
          return false;
        } else {
          // form.submit();
          // we used to send form here, to be sure correct data get saved
          //  but it's causing problems with FF
        }
      });
    });
  },

  cartsItemChange: function () {
    CartsShowView.validateAndSubmitForm()
  },

  validateAndSubmitForm: function () {
    let form = document.querySelector('.edit_cart');

    let debouncedSubmit = General.debounce(function() {
      let jQueryForm = jQuery(form);
      if (jQueryForm.valid()) {
        Rails.fire(form, 'submit');
      }
    }, 1000);

    $('.cart_item_amount').on('input', debouncedSubmit);
    $('.cart_item_amount').keypress( function (e) {
      // disable Enter, we use debouncedSubmit
      if ( e.which == 13 ) return false;
    });
  }
};

export default CartsShowView;
